import React from 'react';
import getConfig from 'next/config';

import {Tenant} from '~/src/utilities/constants/tenant';

import css from '~/src/css/global.module.scss';

const {publicRuntimeConfig: config} = getConfig();

const ShareMail = ({title}) => (
    <svg viewBox="0 0 22 14">
        {title && <title>{title}</title>}
        <g id="Front-Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="Front-Desktop_share"
                transform="translate(-769.000000, -674.000000)"
                fill={config.tenantId === Tenant.LEMATIN ? css.colorTango : css.accentColor}
            >
                <g id="Group-2" transform="translate(0.000000, -7.000000)">
                    <g id="Group-7" transform="translate(747.000000, 252.000000)">
                        <g id="E-Mail" transform="translate(0.000000, 401.000000)">
                            <path
                                d="M23.1654098,28 L32.7150195,36.4663704 C32.821918,36.5605541 33.1698561,36.5605541 33.2767707,36.4663704 L42.8263805,28 L23.1654098,28 Z M22,29.0694444 L22,40.9144815 L28.6402439,34.9595556 L22,29.0694444 Z M44,29.0694444 L37.3597561,34.9595556 L44,40.9144815 L44,29.0694444 Z M29.8309268,36.0126667 L23.1571463,42 L42.843122,42 L36.1693415,36.0126667 L34.3667366,37.6087185 C33.5849049,38.3014333 32.4153366,38.3014333 31.6333707,37.6087185 L29.8309268,36.0126667 Z"
                                id="Fill-1"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default ShareMail;
